<template>
  <div class="Home">
    <div class="user_header">
      <div class="user_card">
        <div class="user_info">
          <div class="avatar">
            <img src="../assets/logo.png" alt="logo"/>
          </div>
          <div class="user_details">
            <div v-show="login_bol" class="phone_num">{{ mobile }}</div>
            <div v-show="login_bol" class="car_badge">{{ car_num }}</div>
            <div @click="gologin" v-show="!login_bol" class="login_btn">登录系统</div>
          </div>
          <div @click="goexit" class="settings_btn" v-show="login_bol">
            <span class="iconfont icon-xiangyou-copy"></span>
          </div>
        </div>
        
        <div class="stats_row">
          <div class="stat_item" @click="goBillList">
            <span class="stat_value">{{ last_share }}<small> 升</small></span>
            <span class="stat_label">最新分配</span>
          </div>
          <div class="stat_divider"></div>
          <div class="stat_item" @click="golineItem">
            <span class="stat_value">{{ order_num }}<small> 升</small></span>
            <span class="stat_label">订单明细</span>
          </div>
          <div class="stat_divider"></div>
          <div class="stat_item" @click="goSiteList">
            <span class="stat_value iconfont icon-ditu" style="font-size: 20px;"></span>
            <span class="stat_label">站点地图</span>
          </div>
        </div>
      </div>
    </div>

    <div class="content_area">
      <div class="section_title">撬装点余额</div>
      <div class="balance_list">
        <div class="balance_card" v-for="item in card_list" :key="item.id"
             @click="goassignationManagement(item.id,item.card_name)">
          <div class="balance_info">
            <span class="card_name">{{ item.card_name }}</span>
            <span class="car_number">{{ item.car_number }}</span>
          </div>
          <div class="balance_amount">
            <span class="amount">{{ item.oil_store }}</span>
            <span class="unit">升</span>
          </div>
        </div>
      </div>
    </div>

    <div class="scan_fab">
      <div class="scan_button" @click="scan">
        <span class="iconfont icon-saoyisaojianjiban"></span>
        <span class="scan_text">扫码加油</span>
      </div>
    </div>
    <!-- 车牌未绑定，弹出提示框 -->
    <div v-show="nocar_num_show" class="nocar_num">
      <div class="nocar_num_content">
        <span class="nocar_num_text">车牌未绑定，请联系车队做司机车牌绑定操作</span>
        <span @click="nocarBt" class="nocar_num_bt">确认</span>
      </div>
    </div>
    <tabbar :selected="selected"></tabbar>
  </div>
</template>

<script>
import common from "../common";
import wx from "weixin-js-sdk";
import {MessageBox} from 'mint-ui';
import tabbar from '@/components/tabbar'

export default {
  name: "Home",
  components: {tabbar},
  data() {
    return {
      selected: "home",
      login_bol: false, //是否登录
      mobile: "",
      order_num: "", //订单总数
      card_list: "", //加油卡列表
      last_share: "", //最新分配数量
      car_num: "",
      nocar_num_show: false,
      sdk_ready: false
    };
  },
  methods: {
    gologin() {
      this.$router.replace("login");
    },
    goexit() {
      this.$router.push("exit");
    },
    nocarBt() {
      this.$router.push("login");
    },
    scan() {
      if (!this.login_bol) {
        this.$router.push("login");
        return;
      }
      

      
      if (!this.sdk_ready) {
        MessageBox('提示', '微信组件尚未准备就绪，请稍后重试或检查签名配置');
        return;
      }

      try {
        // Log location for backend analytics
        wx.getLocation({
          type: 'wgs84',
          success: (res) => {
            let querystring = require('querystring');
            let userInfo = common.getlocalStorage("userInfo");
            if (userInfo) {
              let token = JSON.parse(userInfo).token;
              this.$api.post('wx/User/getLocation',
                querystring.stringify({
                  latitude: res.latitude,
                  longitude: res.longitude,
                  token: token,
                  action: "scan",
                })
              ).catch(e => console.error('Location report failed', e));
            }
          },
          fail: (err) => {
            console.error('wx.getLocation failed', err);
          }
        });

        // Open QR Scanner
        wx.scanQRCode({
          needResult: 1,
          desc: "扫描加油机上的二维码",
          success: (res) => {
            const result = res.resultStr;

            if (result) {
              // Handle various QR formats (some might have prefixes)
              let url = result;
              if (url.includes(',')) {
                url = url.split(',')[1]; // Some scanners return "CODE_128,result"
              }
              
              if (!url.includes("driver.xile.baiduwebs.top")) {
                MessageBox('提示', '请扫描喜乐的专用二维码');
                return;
              }

              let routePath = "";
              if (url.includes("#")) {
                routePath = url.split("#")[1];
              }
              
              if (routePath) {
                this.$router.push({ path: routePath });
              } else {
                MessageBox('提示', '无效的二维码内容');
              }
            }
          },
          fail: (err) => {
            MessageBox('错误', '扫码调起失败，请刷新页面重试');
            console.error('wx.scanQRCode failed', err);
          }
        });
      } catch (e) {
        console.error('Scan error', e);
        MessageBox('提示', '微信组件尚未就绪，请稍后重试');
      }
    },
    goassignationManagement(card_id, card_name) {
      let obj = {
        id: card_id,
        card_name: card_name
      };
      let card_obj = JSON.stringify(obj);
      this.$router.push({
        path: "/assignationManagement/" + card_obj
      });
    },
    golineItem() {
      this.$router.push("lineItem");
    },
    goSiteList() {
      this.$router.push("siteList");
    },
    goBillList() {
      this.$router.push("billList");
    },
    handler() {
      event.preventDefault(); // 阻止默认的处理方式(阻止下拉滑动的效果)
    },
    //获取用户openid
    getOpenid() {
      let url = window.location.href;
      let querystring = require("querystring");
      this.$api.post("/wx/getUrl",
          querystring.stringify({
            url
          })
      ).then(({data}) => {
        window.location.href = data;
      });
    },
    //查询用户是否绑定手机号;
    ifQueryBinding(openid) {
      let querystring = require("querystring");
      this.$api
          .post("/wx/checkOpenid",
              querystring.stringify({
                openid
              })
          )
          .then(({data}) => {
            if (data.status == 1) {
              //绑定了手机号,获取用户信息
              common.setCookie("token", data.data.token, 365);
              common.setCookie("mobile", data.data.mobile, 365);
              this.login_bol = true;
              this.mobile = data.data.mobile;
              this.getData(data.data.token);
            } else {
              //没有绑定了手机号,去登录页绑定
              this.$router.push({
                name: "login",
                query: {
                  openid: openid
                }
              });
            }
          });
    },
    //获取数据
    getData(token) {
      let querystring = require("querystring");
      
      // 核心修复：针对 iOS 和 Android 处理不同的签名 URL
      let signUrl = location.href.split("#")[0];
      const isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      
      // 如果是 iOS，使用我们记录的 entryUrl（在 main.js 或 App.vue 中定义，此处暂取全局）
      if (isiOS && window.entryUrl) {
        signUrl = window.entryUrl;
      }

      this.$api.post("/wx/jsConfig",
          querystring.stringify({
            url: signUrl
          })
      ).then(res => {
          const config = res.data.data || res.data;

          
          const targetAppId = config.appId || config.appid || 'wxb16793e96d8f4266';
          const finalTimestamp = config.timestamp || config.Timestamp;
          const finalNonceStr = config.nonceStr || config.noncestr || config.NonceStr;
          const finalSignature = config.signature || config.Signature;
          
          wx.config({
            debug: false, 
            appId: targetAppId,
            timestamp: finalTimestamp,
            nonceStr: finalNonceStr,
            signature: finalSignature,
            jsApiList: ["checkJsApi", "scanQRCode", "getLocation"]
          });
          
          wx.ready(() => {
            this.sdk_ready = true;

            // Verify if the API is available
            wx.checkJsApi({
              jsApiList: ['scanQRCode', 'getLocation'],
              success: (res) => {

              }
            });
          });

          wx.error((res) => {
            this.sdk_ready = false;
            console.error('wx.config error:', res);
            MessageBox('SDK 错误', JSON.stringify(res));
          });
      }).catch(err => {
        console.error('jsConfig request failed', err);
      });
      //获取账户分配明细和获取订单总数
      this.$api.post("wx/index",
          querystring.stringify({
            token
          })
      ).then(data => {
        if (data.data.status == 1) {
          this.last_share = data.data.data.last_share;
          this.order_num = data.data.data.order_total;
          this.card_list = data.data.data.account_list;
          if (data.data.data.car_number) {
            this.car_num = data.data.data.car_number;
          } else {
            this.nocar_num_show = true;
          }
        } else {
          this.$router.replace({
            name: "login"
          });
        }
      }).catch(err => {
        common.toast(err);
      });
    }
  },
  mounted() {
    //判断cookie中是否存在token
    let ifcookietoken = document.cookie.indexOf("token=") != -1;
    //判断地址栏上是否存在openid;
    let ifopenid = window.location.href.indexOf("openid") != -1;
    //判断是否已经登录
    if (!!JSON.parse(common.getlocalStorage("userInfo"))) {
      this.mobile = JSON.parse(common.getlocalStorage("userInfo")).mobile;
      this.login_bol = true;
      let token = JSON.parse(common.getlocalStorage("userInfo")).token;
      this.getData(token);
    } else if (ifcookietoken) {
      this.login_bol = true;
      let token = common.getCookie("token");
      this.mobile = common.getCookie("mobile");
      this.getData(token);
    } else if (ifopenid) {
      let openid = window.location.href.split("openid=")[1].split("#/")[0];
      this.ifQueryBinding(openid);
    } else {
      this.$router.replace({
        name: "login"
      });
    }
    // 绑定事件
    document.addEventListener("touchmove", this.handler, {
      passive: false
    });
  },
  destroyed() {
    // 解绑事件
    document.removeEventListener("touchmove", this.handler, {
      passive: false
    });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.Home {
  width: 100vw;
  min-height: 100vh;
  background-color: #f6f8fa;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding-bottom: 80px; /* Space for tabbar */
}

.user_header {
  background: linear-gradient(135deg, #106EBE 0%, #005a9e 100%);
  padding: 30px 20px 60px;
  width: 100%;
  box-sizing: border-box;
}

.user_card {
  background: white;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  margin-top: 10px;
}

.user_info {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
}

.avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  overflow: hidden;
  background: #f0f0f0;
  border: 4px solid #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  margin-right: 16px;
  flex-shrink: 0;
}

.avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.user_details {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 6px;
  align-items: flex-start;
}

.phone_num {
  font-size: 18px;
  font-weight: 700;
  color: #333;
}

.car_badge {
  display: inline-block;
  background: #106EBE;
  color: white;
  font-size: 12px;
  padding: 2px 10px;
  border-radius: 4px;
  width: fit-content;
  font-weight: 600;
}

.login_btn {
  background: #106EBE;
  color: white;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  width: fit-content;
}

.settings_btn {
  padding: 10px;
  color: #adb5bd;
}

.stats_row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 15px;
  border-top: 1px solid #f1f3f5;
}

.stat_item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.stat_value {
  font-size: 20px;
  font-weight: 700;
  color: #106EBE;
}

.stat_value small {
  font-size: 12px;
  font-weight: 500;
  color: #666;
}

.stat_label {
  font-size: 12px;
  color: #868e96;
}

.stat_divider {
  width: 1px;
  height: 30px;
  background-color: #e9ecef;
}

.content_area {
  margin-top: -30px;
  padding: 0 20px;
  width: 100%;
  box-sizing: border-box;
}

.section_title {
  font-size: 16px;
  font-weight: 700;
  color: #333;
  margin-bottom: 12px;
  padding-left: 4px;
}

.balance_list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.balance_card {
  background: white;
  border-radius: 12px;
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: transform 0.2s;
}

.balance_card:active {
  transform: scale(0.98);
}

.balance_info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.card_name {
  font-size: 15px;
  font-weight: 600;
  color: #495057;
}

.car_number {
  font-size: 12px;
  color: #adb5bd;
}

.balance_amount {
  text-align: right;
}

.amount {
  font-size: 18px;
  font-weight: 700;
  color: #e03131; /* Use a softer red */
}

.unit {
  font-size: 12px;
  color: #868e96;
  margin-left: 2px;
}

.scan_fab {
  position: fixed;
  bottom: 100px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  pointer-events: none;
  z-index: 99;
}

.scan_button {
  pointer-events: auto;
  background: linear-gradient(135deg, #106EBE 0%, #005a9e 100%);
  color: white;
  padding: 12px 24px;
  border-radius: 30px;
  display: flex;
  align-items: center;
  gap: 10px;
  box-shadow: 0 8px 20px rgba(16, 110, 190, 0.4);
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.scan_button:active {
  transform: scale(0.9);
  box-shadow: 0 4px 10px rgba(16, 110, 190, 0.3);
}

.scan_button .iconfont {
  font-size: 24px;
}

.scan_text {
  font-size: 16px;
  font-weight: 700;
}

/* Alert overlay optimization */
.nocar_num {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.6);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
}

.nocar_num_content {
  background: white;
  border-radius: 20px;
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.nocar_num_text {
  padding: 30px 20px;
  text-align: center;
  font-size: 15px;
  line-height: 1.5;
  color: #495057;
}

.nocar_num_bt {
  background: #106EBE;
  color: white;
  border: none;
  height: 50px;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
}

</style>



// WEBPACK FOOTER //
// src/components/home.vue